import * as React from "react";
import {
  TrackerPolicy,
  TrackerPolicyContentStatusOptions,
  TrackerPolicyContentTypeOptions
} from "@models/tracker-policy";
import {Table, Button, Divider, Avatar, Tooltip} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {Icon} from 'antd';
import {SubscriptionStatusOptions} from "@models/subscription";
import {PaymentGatewayOptions} from "@models/paymentGateway";
import {getFormattedPrice} from "@utils";
import __i18n from "../../../../../intl/__i18n";

type Props = {
  data: TrackerPolicy[];
  loading: boolean;
  deleteFn: (item: TrackerPolicy) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const UserPurchasesTable: React.FC<Props> = props => {
  const {data, loading, currentPage} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: __i18n("Package Title"),
      dataIndex: "package",
      key: "package",
      align: "right",
      render: (status, record) => record.package.title
    },
    {
      title: <FormattedMessage id="app.payment_gateway" defaultMessage={`payment_gateway`}/>,
      dataIndex: "payment_gateway",
      key: "payment_gateway",
      align: "center",
      render: (payment_gateway, record) => PaymentGatewayOptions.find(item => item.value === payment_gateway)["label"]
    },
    {
      title: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
      dataIndex: "status",
      key: "status",
      align: "right",
      render: (status, record) => SubscriptionStatusOptions.find(item => item.value === status)["label"]
    },
    {
      title: <FormattedMessage id="app.price" defaultMessage={`Price`}/>,
      dataIndex: "price",
      key: "price",
      render: (price, record) => getFormattedPrice(price)
    },
    {
      title: <FormattedMessage id="app.effective_price" defaultMessage={`Effective Price`}/>,
      dataIndex: "effective_price",
      key: "effective_price",
      align: "center",
      render: (effective_price, record) => getFormattedPrice(effective_price)
    },
    {
      title: __i18n("Used balance amount"),
      dataIndex: "used_internal_balance_amount",
      key: "used_internal_balance_amount",
      align: "center",
    },
    {
      title: (<FormattedMessage id="app.start_time" defaultMessage={`Start Time`}/>),
      dataIndex: "start_time",
      key: "start_time",
      align: "center",
      render: (start_time, record) => <FormattedDateTime date={start_time}/>
    },
    {
      title: (<FormattedMessage id="app.end_time" defaultMessage={`End Time`}/>),
      dataIndex: "end_time",
      key: "end_time",
      align: "left",
      render: (end_time, record) => <FormattedDateTime date={end_time}/>
    },
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default UserPurchasesTable;
